import { Quote } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { REVIEWS } from "@/lib/data";
import { FadeUp, MaskLines, SectionLabel } from "./Reveal";

const Card = ({ r, i }) => (
  <figure data-testid={`review-card-${i}`} className="flex w-[260px] shrink-0 snap-start flex-col justify-between border border-white/10 bg-ink p-5 transition-colors duration-300 hover:border-brand/60 sm:w-[300px]">
    <div>
      <Quote aria-hidden className="h-5 w-5 text-brand" />
      <blockquote className="mt-3 text-sm leading-relaxed text-bone">“{r.text}”</blockquote>
    </div>
    <figcaption className="mt-4 flex items-center gap-3 border-t border-white/10 pt-3">
      <span className="grid h-8 w-8 shrink-0 place-items-center rounded-full bg-brand font-display text-xs font-black text-cream">{r.name.charAt(0)}</span>
      <span className="min-w-0">
        <span data-testid={`review-name-${i}`} className="block font-display text-xs font-extrabold uppercase text-bone">{r.name}</span>
        <span className="block font-mono text-[11px] uppercase leading-snug tracking-[0.12em] text-zinc-300">{r.tag}</span>
      </span>
    </figcaption>
  </figure>
);

export const Reviews = () => {
  const { t } = useLang();
  const v = t.reviews;
  return (
    <section id="reviews" data-testid="reviews-section" className="relative bg-coal py-16 md:py-20">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <SectionLabel n="05">{v.label}</SectionLabel>
        <h2 className="font-display mt-6 text-3xl font-black uppercase leading-[0.95] text-bone sm:text-4xl">
          <MaskLines inView lines={[v.l1, <span key="r" className="font-serif-i normal-case text-brand">{v.l2}</span>]} />
        </h2>
        <FadeUp>
          <div data-testid="reviews-track" className="mt-8 flex snap-x snap-mandatory gap-3 overflow-x-auto pb-3 [scrollbar-width:thin]">
            {REVIEWS.map((r, i) => <Card key={r.name} r={r} i={i} />)}
          </div>
        </FadeUp>
      </div>
    </section>
  );
};
